module.exports = __webpack_public_path__ + "static/gothamhtf-book-f77b30c0e8a684fa7b6fe0c806ca90d2.woff2";